"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _classnames = _interopRequireDefault(require("classnames"));

require("../styles/_share-type.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function goToOrgShareSettings(onClose, type) {
  return function () {
    onClose();
    window.open("".concat(window.location.origin, "/organisation/settings/social#").concat(type), '_blank');
  };
}

function ShareType(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      type = _ref.type,
      accountId = _ref.accountId,
      onShare = _ref.onShare,
      onClose = _ref.onClose;
  var onClickButton = goToOrgShareSettings(onClose, type);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('share-type', {
      'share-type--no-account': !accountId
    })
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: icon,
    size: 40
  }), /*#__PURE__*/_react.default.createElement(_commonReact.Form.FormBlockDescription, {
    className: "share-type__content",
    name: title,
    description: accountId || 'Account not connected',
    buttonText: accountId ? 'Share' : 'Connect',
    isPrimaryButton: accountId,
    onClickButton: !accountId ? onClickButton : onShare,
    hideButton: !accountId,
    highlightedName: Boolean(accountId)
  }));
}

var _default = /*#__PURE__*/(0, _react.memo)(ShareType);

exports.default = _default;